import { Modal } from 'antd'
import DateCell from '../../../../../../elements/Table/Cells/DateCell'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import React from 'react'

function ActivityList(props) {
  const { list, submitting, visible, onCancel, type } = props

  const columns = [
    { Header: 'Code', accessor: 'code', width: 200 },
    {
      Header: 'Title',
      accessor: 'title',
      width: 450,
      style: { paddingLeft: 20, alignment: 'left' },
    },
    { Header: 'Action Date', accessor: 'date', Cell: DateCell },
  ]

  console.log({ type, list })
  return (
    <Modal visible={visible} title={type} onCancel={onCancel} destroyOnClose={true} width={'75%'}>
      <CustomTable
        data={list}
        defaultPageSize={20}
        isFilterable={true}
        fetching={submitting}
        show={{ csv: { fileName: `Activity-Report-${type}` } }}
        columns={columns}
        defaultSorted={[
          {
            id: 'date',
            desc: true,
          },
        ]}
      />
    </Modal>
  )
}

export default ActivityList
